import React, { useMemo, useState } from "react";
import { getMaterialOptions } from "../data/machiningMaterials";

const MaterialSelector = ({
  value,
  onChange,
  label = "Workpiece Material",
  error = "",
}) => {
  const [query, setQuery] = useState("");
  const options = useMemo(() => getMaterialOptions(), []);
  const selected = options.find((option) => option.value === value);

  const filteredOptions = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return options;

    return options.filter((option) => {
      return [option.label, option.group, option.value, ...(option.searchKeywords || [])]
        .join(" ")
        .toLowerCase()
        .includes(normalizedQuery);
    });
  }, [options, query]);

  return (
    <div className="form-group">
      <label>{label}</label>
      <input
        type="search"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Search material, grade, or family..."
        style={inputStyle}
      />
      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className={error ? "error" : ""}
        style={selectStyle}
      >
        {filteredOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.group} - {option.label}
          </option>
        ))}
      </select>
      {selected && (
        <div style={metaStyle}>
          SFM baseline: {selected.sfm} | Chip load baseline: {selected.chipLoad}" |
          Hardness: {selected.hardnessRockwell || "N/A"} Rockwell
          {selected.hardnessRockwellTypical ? ` | ${selected.hardnessRockwellTypical}` : ""}
          {selected.heatTreatmentNotes ? ` | ${selected.heatTreatmentNotes}` : ""}
        </div>
      )}
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

const inputStyle = {
  width: "100%",
  minHeight: "42px",
  marginBottom: "8px",
  padding: "10px 12px",
  borderRadius: "14px",
  border: "1px solid var(--border-soft)",
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.055), rgba(255,255,255,0.02)), var(--bg-panel)",
  color: "var(--text-primary)",
  boxSizing: "border-box",
};

const selectStyle = {
  width: "100%",
  minHeight: "44px",
  padding: "10px 38px 10px 12px",
  borderRadius: "14px",
  border: "1px solid var(--border-soft)",
  backgroundColor: "var(--bg-panel)",
  backgroundImage:
    "linear-gradient(45deg, transparent 50%, var(--text-muted) 50%), linear-gradient(135deg, var(--text-muted) 50%, transparent 50%)",
  backgroundPosition: "calc(100% - 18px) 50%, calc(100% - 12px) 50%",
  backgroundSize: "6px 6px, 6px 6px",
  backgroundRepeat: "no-repeat",
  color: "var(--text-primary)",
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  boxSizing: "border-box",
};

const metaStyle = {
  marginTop: "8px",
  color: "var(--text-muted)",
  fontSize: "12px",
  lineHeight: 1.5,
};

export default MaterialSelector;
